import type { RecordedLink, Side } from '../../engine';
import { t } from '../../i18n';
import { faceLong, recordedMoveWords } from '../../app/describe';
import { Glyph } from './Glyph';

/**
 * A recorded route (an inscription or an Epitaph) step by step, in words: each link as the small
 * face of the card that made it, then where it went from its owner's side ("2 squares forward").
 */
export function RouteSteps({ links, owner }: { links: readonly RecordedLink[]; owner: Side }) {
  return (
    <ol className="route-steps">
      {links.map((l, k) => (
        <li key={k} className={`route-step c-${l.face.color}`}>
          <span className="route-face">
            <Glyph color={l.face.color} size={13} />
            <span className="sr-only">
              {l.wasWild ? t('card.wildNamed', { face: faceLong(l.face) }) : faceLong(l.face)}:
            </span>
            <strong aria-hidden="true">{l.face.number}</strong>
            {l.wasWild && (
              <span className="route-wild" aria-hidden="true">
                W
              </span>
            )}
          </span>
          <span>{recordedMoveWords(l, owner)}</span>
        </li>
      ))}
    </ol>
  );
}
